<template>
  <v-container id="smslogs" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
        >
          <v-row>
            <v-col cols="12" md="2" lg="2">
              <z-date-picker
                :label="$i18n.t('From Date')"
                v-model="filters.podDateFrom"
              />
            </v-col>
            <v-col cols="12" md="2" lg="2">
              <z-date-picker
                :label="$i18n.t('Till Date')"
                v-model="filters.podDateTill"
              />
            </v-col>
            <v-col cols="12" md="2" lg="2">
              <z-client-select v-model="filters.client_id" withSelf />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-entity-select
                corp="self"
                v-model="filters.entity_id"
                :label="$i18n.t('Company Entity')"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <v-select
                :items="[
                  { name: 'POD Received/Submitted', value: '20,21' },
                  { name: 'Cancelled', value: '7' },
                ]"
                v-model="filters.status"
                :label="$i18n.t('Status')"
                item-text="name"
                item-value="value"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <v-select
                :items="[
                  { name: 'Date', value: '1' },
                  { name: 'Month', value: '2' },
                ]"
                v-model="filters.groupByDate"
                :label="$i18n.t('Group by Date/Month')"
                item-text="name"
                item-value="value"
              />
            </v-col>
            <v-col cols="12" sm="4" md="3" lg="3">
              <v-checkbox
                v-model="filters.groupByEntity"
                :label="$i18n.t('Group by Entity')"
              />
            </v-col>
            <v-col cols="12" sm="4" md="3" lg="3">
              <v-checkbox
                v-model="filters.groupByClient"
                :label="$i18n.t('Group by Client')"
              />
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2" class="text-right">
              <v-btn
                color="success"
                class="mr-3"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>

              <v-btn
                color="orange"
                class="mr-3"
                fab
                small
                dark
                @click="download()"
                :loading="loading"
              >
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-row>
      <v-simple-table dense style="width: 100%">
        <thead>
          <tr>
            <th>
              <b>{{ $i18n.t("SR.#") }}</b>
            </th>
            <th>
              <b>{{ $i18n.t("Date") }}</b>
            </th>
            <th>
              <b>{{ $i18n.t("Client") }}</b>
            </th>
            <th>
              <b>{{ $i18n.t("Entity") }}</b>
            </th>
            <th style="text-align: right">
              <b>{{ $i18n.t("Sub Total") }}</b>
            </th>
            <th style="text-align: right">
              <b>{{ $i18n.t("Taxes") }}</b>
            </th>
            <th style="text-align: right">
              <b>{{ $i18n.t("Supplier Amount") }}</b>
            </th>
            <th style="text-align: right">
              <b>{{ $i18n.t("Expenses") }}</b>
            </th>
            <th style="text-align: right">
              <b>{{ $i18n.t("Margin") }}</b>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(report, index) in tripRevenueReports" :key="index">
            <td>
              {{ index + 1 == tripRevenueReports.length ? "" : index + 1 }}
            </td>
            <td>{{ getFormattedDateOrMonth(report.date) }}</td>
            <td>{{ report.client ? report.client.name : "" }}</td>
            <td>{{ report.entity ? report.entity.name : "" }}</td>
            <td style="text-align: right">
              <span v-for="(k, v) in report.subTotal" :key="v + index"
                >{{ k }} {{ v }} <br
              /></span>
            </td>
            <td style="text-align: right">
              <span v-for="(k, v) in report.taxes" :key="v + index"
                >{{ k }} {{ v }} <br
              /></span>
            </td>
            <td style="text-align: right">
              <span v-for="(k, v) in report.supTotal" :key="v + index"
                >{{ k }} {{ v }} <br
              /></span>
            </td>
            <td style="text-align: right">
              <span v-for="(k, v) in report.expenses" :key="v + index"
                >{{ k }} {{ v }} <br
              /></span>
            </td>
            <td style="text-align: right">
              <span v-for="(k, v) in report.margin" :key="v + index"
                >{{ k }} {{ v }} <br
              /></span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doGetWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class TripRevenue extends Vue {
  tripRevenueReports = [];
  webcontent = {};
  url = "/api/report/trip/client/revenue/margin?&";
  filterUrl = "";
  download_filterUrl = "";
  download_url = "/api/report/trip/client/revenue/margin/download?&";
  filters = {
    podDateFrom: null,
    podDateTill: null,
    client_id: null,
    entity_id: null,
    status: null,
    groupByDate: null,
    groupByEntity: null,
    groupByClient: null,
  };

  prepareUrl(_url) {
    let url = "";
    if (this.filters.podDateFrom)
      url = url + "&podDateFrom=" + this.filters.podDateFrom;
    if (this.filters.podDateTill)
      url = url + "&podDateTill=" + this.filters.podDateTill;
    if (this.filters.client_id)
      url = url + "&corp_id=" + this.filters.client_id;
    if (this.filters.entity_id)
      url = url + "&vendorEntity_id=" + this.filters.entity_id;
    if (this.filters.status) url = url + "&status=" + this.filters.status;
    if (this.filters.groupByDate)
      url = url + "&groupByDate=" + this.filters.groupByDate;
    if (this.filters.groupByEntity == true) url = url + "&groupByEntity=true";
    if (this.filters.groupByClient == true) url = url + "&groupByClient=true";
    return _url + url;
  }

  async search() {
    if (!this.filters.podDateFrom || !this.filters.podDateFrom) {
      common.setError("Provide dates");
      return;
    }
    const date1 = new Date(
      this.formatIntegerDate_MMDDYYYY(this.filters.podDateFrom, "/")
    );
    const date2 = new Date(
      this.formatIntegerDate_MMDDYYYY(this.filters.podDateTill, "/")
    );
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 184) {
      common.setError("Provide dates within range of 6 months");
      return;
    }

    this.filterUrl = this.prepareUrl(this.url);
    common.setLoading(true);
    try {
      const response = await doGet(this.filterUrl);
      this.tripRevenueReports = response;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async download() {
    if (!this.filters.podDateFrom || !this.filters.podDateFrom) {
      common.setError("Provide dates");
      return;
    }
    const date1 = new Date(
      this.formatIntegerDate_MMDDYYYY(this.filters.podDateFrom, "/")
    );
    const date2 = new Date(
      this.formatIntegerDate_MMDDYYYY(this.filters.podDateTill, "/")
    );
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 184) {
      common.setError("Provide dates within range of 6 months");
      return;
    }

    this.download_filterUrl = this.prepareUrl(this.download_url);
    common.setLoading(true);
    try {
      await doGetWithDownload(this.download_filterUrl);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    const d = new Date();
    const year = d.getFullYear();
    let day = d.getDate();
    let month = d.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    this.filters.podDateTill = year + "" + month + "" + day;
  }

  get loading() {
    return common.loading;
  }

  getFormattedDateOrMonth(intDate) {
    if (intDate && intDate > 999999) {
      return this.formatIntegerDate(intDate);
    }
    return this.formatIntegerMonth(intDate);
  }

  formatIntegerDate_MMDDYYYY(date, seperator) {
    if (date) {
      seperator = !seperator ? "-" : seperator;
      const dateStr = date.toString();
      return (
        dateStr.substring(4, 6) +
        seperator +
        dateStr.substring(6, 8) +
        seperator +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
  formatIntegerDate(date, seperator) {
    if (date) {
      seperator = !seperator ? "-" : seperator;
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        seperator +
        dateStr.substring(4, 6) +
        seperator +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
  monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  formatIntegerMonth(intMonth) {
    if (intMonth) {
      intMonth = intMonth.toString();
      if (intMonth.indexOf("-") == -1) {
        intMonth =
          this.monthsShort[parseInt(intMonth.substring(4, 6)) - 1] +
          " " +
          intMonth.substring(0, 4);
      }
    }
    return intMonth;
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

.v-card__subtitle,
.v-card__text {
  font-size: 14px;
}

.v-expansion-panel-header--active {
  background-color: aliceblue;
  min-height: 50px !important;
}

tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}
</style>
